module.exports = __webpack_public_path__ + "static/img/8.7705b18.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/8.png
// module id = 432
// module chunks = 1 2 3 4 5 6 7 8